import { useState } from "react";
import CallMadeIcon from "@mui/icons-material/CallMade";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { getDefaultImg } from "../../../../utils/getDefaultCourseImage";
import { useCoursesStyles } from "./styles";
import { toast } from "react-toastify";
import { CourseRequestDialog } from "./AddCoursePopup";
import { commonStyles } from "../../styles";
import uploadIcon from "../../../../assets/images/upload_icon.svg";
import highlightImg from "../../../../assets/images/mentor_profile/highlight.png";
import { DESKTOP_BREAKPOINT } from "../../consts";

export const Courses = ({
  mentorCourses,
  mentorCoursesLoading,
  isProfilePage = false,
}) => {
  const commonClasses = commonStyles();
  const classes = useCoursesStyles();
  const [isExpanded, setIsExpanded] = useState(false);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(DESKTOP_BREAKPOINT));
  const defaultLimit = isMobile ? 3 : 10;

  return (
    <section className={classes.courseWrapper}>
      <div className={classes.header}>
        <h2 className={classes.title}>
          Courses{" "}
          <span className={classes.titleHighlight}>
            I teach
            <img
              src={highlightImg}
              alt=""
              className={classes.titleHighlightImg}
            />
          </span>
        </h2>
        {!isProfilePage && mentorCourses?.length > 0 && (
          <button
            className={`${commonClasses.buttonReset} ${commonClasses.viewProfileBtn} ${classes.requestCourseBtn}`}
            onClick={() => setOpen(true)}
            
          >
            Request course{" "}
            <AddCircleOutlineOutlinedIcon style={{ fontSize: 18, verticalAlign: "middle" }} />
          </button>
        )}
        {open && <CourseRequestDialog open={open} setOpen={setOpen} />}
      </div>

      {mentorCourses?.length > 0 ? (
        <div className="cardContainer">
          {mentorCourses
            ?.slice(0, isExpanded ? undefined : defaultLimit)
            .map((courseData) => (
              <CourseCard
                courseData={courseData}
                key={courseData?.["Course.CourseId"]}
                isProfilePage={isProfilePage}
              />
            ))}
        </div>
      ) : isProfilePage ? (
        <div style={{ marginTop: "20px" }} onClick={() => setOpen(true)}>
          <p>No courses available</p>
        </div>
      ) : (
        <div
          className={classes.requestCourseCard}
          onClick={() => setOpen(true)}
        >
          <img src={uploadIcon} alt="upload icon" width="24px" height="24px" />
          <p>Request Course</p>
        </div>
      )}

      {mentorCourses?.length > defaultLimit && (
        <button
          className={`${commonClasses.buttonReset} `}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            margin: "20px auto",
            color: "#404040",
            fontWeight: 600,
          }}
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? "View less" : "View More"}
          <KeyboardArrowDownIcon
            style={{
              fontSize: 20,
              transition: "transform 0.2s ease",
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
      )}
    </section>
  );
};

const CourseCard = ({ courseData, isProfilePage }) => {
  const handleCurriculumClick = (curriculum) => {
    if (!curriculum) {
      toast.error("Curriculum not Available!");
    }
  };

  const courseName = courseData?.["Course.courseName"] ?? "";
  const demoDoc = courseData?.["Course.DemoDocument"];
  const fullDoc = courseData?.["Course.curriculum"];

  return (
    <div className="mentorCourseCard">
      <div className="cardTop">
        <div className="courseName">{courseName}</div>
        <img src={getDefaultImg(courseName)} alt={courseName} className={"courseImg"} />
      </div>

      {!isProfilePage && (
        <div className="cardBottom">
          <a
            className="curriculumLink"
            href={demoDoc || undefined}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleCurriculumClick(demoDoc)}
          >
            Demo curriculum
            <CallMadeIcon style={{ fontSize: 15, verticalAlign: "middle" }} />
          </a>
          <a
            className="curriculumLink"
            href={fullDoc || undefined}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleCurriculumClick(fullDoc)}
          >
            Full curriculum
            <CallMadeIcon style={{ fontSize: 15, verticalAlign: "middle" }} />
          </a>
        </div>
      )}
    </div>
  );
};
